// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/aeronautical-publications.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/aeronautical-publications/aeronautical-publications.js';

mount([g0]);
